import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { ptApi, ptError, TOKEN_KEY } from "@/pathlync/api";

const Ctx = createContext(null);
export const usePathLync = () => useContext(Ctx);

export function PathLyncProvider({ children }) {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    if (!localStorage.getItem(TOKEN_KEY)) { setChecking(false); return; }
    ptApi.get("/auth/me")
      .then(({ data }) => setUser(data))
      .catch(() => localStorage.removeItem(TOKEN_KEY))
      .finally(() => setChecking(false));
  }, []);

  const authenticate = useCallback(async (path, body) => {
    try {
      const { data } = await ptApi.post(path, body);
      localStorage.setItem(TOKEN_KEY, data.token);
      setUser(data.user);
      return { ok: true, user: data.user };
    } catch (e) { return { ok: false, error: ptError(e) }; }
  }, []);

  const signIn = useCallback((body) => authenticate("/auth/login", body), [authenticate]);
  const register = useCallback((body) => authenticate("/auth/register", body), [authenticate]);
  const signOut = useCallback(() => {
    localStorage.removeItem(TOKEN_KEY);
    setUser(null);
  }, []);

  return (
    <Ctx.Provider value={{ user, checking, signIn, register, signOut }}>
      {children}
    </Ctx.Provider>
  );
}
